/**
 * @author      luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright   Copyright (c) 2024, Zumper
 * @description Inactive save search modal constants
 */

export const CLEAR_DATA = '@@nzr/modals/inactiveSaveSearchModal/CLEAR_DATA'
export const RECEIVE_DATA = '@@nzr/modals/inactiveSaveSearchModal/RECEIVE_DATA'
